export default import.meta.ROLLDOWN_FILE_URL_8Qy3eYGhg1HJICLIVd0IJw